export { default as DbLogoText } from './db-logo-text';